import { RatchetBracketLine } from '../../../../components/displays/charts/d3/candlestickchart/newCandleChart/softOrders/softOrderChartComponents/exitTactics/RatchetBracketLine';
import { RatchetBracketTacticPanel } from '../../../../components/displays/tradeplans/activeTradePlanModule/components/detailsSection/individualTacticPanels/exits/RatchetBracketTacticPanel';
import { AddRatchetBracketTacticPanel } from '../../../../components/displays/tradeplans/activeTradePlanModule/components/detailsSection/panels/tacticsPanel/addTacticPanel/individualAddTacticPanels/AddRatchetBracketTacticPanel';
import { RatchetBracketWrapper } from '../../../../components/displays/tradeplans/softOrderModules/exitTacticModules/RatchetBracketModule/wrapper/RatchetBracketWrapper';
import RatchetBracketDocs from '../../../../components/forms/tradeplans/documentation/RatchetBracketDocs';
import RatchetBracketModule from '../../../../components/forms/tradeplans/tradingPlanFormComponents/FieldComponents/exitTactics/modules/RatchetBracketModule';
import { RatchetBracketData } from './ratchetBracketData';
import { validateRatchetBracket } from './validateRatchetBracket';

export const RatchetBracket = {
  //data class
  dataStore: RatchetBracketData,

  //string constants
  name: 'RATCHET_BRACKET',
  tacticLabel: 'Ratchet Bracket',
  addTacticLabel: 'Add Ratchet Bracket',
  category: 'Exit',

  // components
  tradePlanFormModule: RatchetBracketModule,
  tacticPanel: RatchetBracketTacticPanel,
  addTacticPanel: AddRatchetBracketTacticPanel,
  wrapper: RatchetBracketWrapper,
  chartSoftOrderComponent: RatchetBracketLine,
  documentation: RatchetBracketDocs,
  alertDetailsComponent: null,

  //functions
  setupDetailParser: null,
  validationFunction: validateRatchetBracket,
};
